// Injected at build time from package.json (see the start/build scripts).
// Bump package.json "version" on each release, together with the main frontend,
// and add a matching entry at the top of data/changelog.js.
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
